import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const DiamondIcon = ({
  title = 'Diamond',
  className = 'diamond-icon',
  color = 'currentColor',
  viewBox = '0 0 14 14',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} {...props} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.5 2.917h7l1.75 2.916-4.958 5.542a.408.408 0 0 1-.584 0L1.75 5.833 3.5 2.917"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.833 7 4.667 5.717l.35-.584"
    />
  </CreateIconComponent>
);

export default DiamondIcon;
